import styled, { keyframes } from "styled-components";

// ============================================
// ANIMATIONS
// ============================================

const blink = keyframes`
  0% { opacity: 1; }
  49% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 0; }
`;

// ============================================
// TOOLBAR / NAVBAR STYLES
// ============================================

export const ToolBar = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-bottom: double;
  padding-bottom: 1px;
  border-width: thick;
`;

export const ToolBarName = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: solid;
`;

export const NameBar = styled.div`
  font-size: 3.25vh;
  padding-left: 1vh;
  padding-right: 1vh;
  white-space: nowrap;
  font-family: "VT323", monospace;
  padding-bottom: 1px;
  padding-top: 1px;

  @media only screen and (max-width: 480px) {
    font-size: 3.25vh;
  }

  @media only screen and (min-width: 1900px) {
    font-size: 2.25vh;
  }
`;

export const NameBarFill = styled.div`
  margin: 5px;
  width: 100%;
  background-image: url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="10"><line x1="0" y1="0" x2="100%" y2="0" stroke="black" stroke-width="2" /><line x1="0" y1="10" x2="100%" y2="10" stroke="black" stroke-width="2" /></svg>');
  background-repeat: repeat;
`;

export const ToolBarTiles = styled.div`
  height: 3vh;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 1px;

  @media only screen and (max-width: 480px) {
    height: auto;
    min-height: 2.5vh;
  }

  @media only screen and (min-width: 1900px) {
    height: 2vh;
  }
`;

export const ToolBarEntries = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 3vh;
  margin-left: 1px;

  @media only screen and (max-width: 480px) {
    height: 2.5vh;
    flex-wrap: wrap;
  }

  @media only screen and (min-width: 1900px) {
    height: 2vh;
  }
`;

export const ToolBarButton = styled.a`
  text-decoration: none;
  text-decoration-color: black;
  color: black;
`;

export const ToolBarEntry = styled.div`
  font-family: "VT323", monospace;
  font-size: 3vh;
  color: black;

  &:hover {
    background-color: black;
    color: white;
  }

  @media only screen and (max-width: 480px) {
    font-size: 2vh;
  }

  @media only screen and (min-width: 1900px) {
    font-size: 2vh;
  }
`;

export const ToolBarEntryText = styled.p`
  margin: 0;
  padding-left: 1vh;
  padding-right: 1vh;
  line-height: 3vh;

  @media only screen and (max-width: 480px) {
    padding-left: 0.5vh;
    padding-right: 0.5vh;
    line-height: 2.5vh;
  }

  @media only screen and (min-width: 1900px) {
    line-height: 2vh;
  }
`;

// ============================================
// CONTENT STYLES
// ============================================

export const HomeContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  box-sizing: border-box;
  width: 90%;
  max-width: 600px;
  padding: 0 20px;
  margin: 0 auto;
  height: 100%;
  overflow-y: scroll;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media only screen and (max-width: 480px) {
    width: 95%;
    padding: 0 10px;
  }
`;

export const Typewriter = styled.div`
  padding-top: 1vh;
  margin-top: 0;
  width: 100%;
  box-sizing: border-box;
`;

export const HomeText = styled.div`
  width: 100%;
  box-sizing: border-box;
`;

export const Output = styled.div`
  font-family: "IBM Plex Mono", monospace;
  color: var(--licorice);
  margin-top: 0;
  margin-bottom: 0;

  & > h1 {
    font-size: 2.5vh;

    @media only screen and (min-width: 1900px) {
      font-size: 1.75vh;
    }
  }
`;

export const CursorH1 = styled.h1`
  margin-top: 2vh;
  margin-bottom: 0;

  &::after {
    content: "";
    display: inline-block;
    margin-left: 3px;
    background-color: rgb(8, 8, 8);
    animation: ${blink} 0.5s infinite;
    line-height: 1vh;
    vertical-align: middle;
    height: 2.6vh;
    width: 1vh;
    line-height: 2.6vh;
  }
`;

export const MainboxText = styled.p`
  font-family: "IBM Plex Mono", monospace;
  font-size: 2vh;
  color: var(--licorice);
  width: 100%;
  margin: 1vh 0;

  @media only screen and (max-width: 480px) {
    font-size: 2vh;
  }

  @media only screen and (min-width: 1900px) {
    font-size: 1.5vh;
  }
`;

export const LinkText = styled.p`
  font-family: "IBM Plex Mono", monospace;
  font-size: 2vh;
  color: var(--licorice);
  margin-top: 1px;
`;

export const HomeImage = styled.img`
  display: block;
  margin: 0;
  height: 15vh;
  width: auto;
  max-width: 100%;
  max-height: 15vh;
  object-fit: contain;
`;

// ============================================
// PROJECTS STYLES
// ============================================

export const ProjectsSection = styled.div`
  margin-top: 20px;
  font-family: "VT323", monospace;
`;

export const ProjectsTitle = styled.h2`
  font-size: 3vh;
  margin-bottom: 10px;
`;

export const ProjectCard = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  border: 1px solid black;
  padding: 10px;
`;

export const ProjectImage = styled.img`
  width: 100px;
  height: auto;
  margin-right: 15px;
`;

export const ProjectInfo = styled.div`
  flex-grow: 1;
`;

export const ProjectName = styled.h3`
  font-size: 2.5vh;
  margin: 0;
`;

export const ProjectDescription = styled.p`
  font-size: 2vh;
  margin: 0;
`;

export const ProjectTechStack = styled.p`
  font-size: 2vh;
  margin: 0;
`;

export const ProjectLinks = styled.div`
  margin-top: 5px;

  a {
    color: blue;
    text-decoration: underline;

    &:hover {
      color: darkblue;
    }
  }
`;
